module.exports = __webpack_public_path__ + "img/lpr_night_down.6ec16755.svg";